<template>
<div>
  <div class="information-subheader first" v-html="$t('information.age-restriction')"></div>
  <div class="information-alt" v-html="$t('information.age')"></div>
  <div class="information-flow" v-html="$t('information.age-info')"></div>

  <div class="information-subheader" v-html="$t('information.types-header')"></div>
  <div class="information-subsubheader first" v-html="$t('information.types-musical')"></div>
  <div class="information-alt" v-html="$t('information.types-musical-length')"></div>
  <div class="information-flow" v-html="$t('information.types-musical-info')"></div>

  <div class="information-subsubheader" v-html="$t('information.types-concert')"></div>
  <div class="information-alt" v-html="$t('information.types-concert-length')"></div>
  <div class="information-flow" v-html="$t('information.types-concert-info')"></div>

  <div class="information-subheader" v-html="$t('information.group')"></div>
  <div class="information-alt" v-html="$t('information.group-name')"></div>
  <div class="information-flow" v-html="$t('information.group-info')"></div>
</div>
</template>

<script>
export default {
  name: "group-information",
  data: function () {
    return {};
  }
}
</script>

<style lang="scss">
  @import '../../assets/scss/var';

  .information-subheader {
    font-weight: 700;
    font-family: $condensed_font;
    font-size: 22px;
    margin-bottom: 20px;

    &:not(.first) {
      margin-top: 44px;
    }
  }

  .information-subsubheader {
    font-weight: 700;
    margin-bottom: 10px;
    // margin-top: 20px;

    &:not(.first) {
      margin-top: 32px;
    }
  }

  .information-alt {
    margin-bottom: 8px;
    font-style: italic;
    // font-size: 16px;
  }

  .information-flow {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupInformation.vue